// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_REGEX = /[\u0000-\u001F\u007F]/g; // 제어문자 제거
const ANCHOR_OR_RELATIVE_REGEX = /^(#|\/(?!\/)|\.{1,2}\/)/; // #, /, ./, ../ 로 시작
const PROTOCOL_RELATIVE_REGEX = /^\/\//; // //로 시작
const SCHEME_REGEX = /^([a-z][a-z0-9+.-]*):/i; // 스킴 추출 → 여기서 불필요 escape 제거
const DOMAIN_LIKE_REGEX = /^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?(\/.*)?$/i; // 도메인 패턴

// 허용되는 스킴 집합
const ALLOW_SCHEMES = new Set(['http', 'https', 'mailto', 'tel']);

/**
 * 입력 문자열을 안전한 URL로 정규화합니다.
 */
export const normalizeUrl = (raw: string): string | null => {
  if (!raw) return null;

  // 공백/제어문자 제거
  let sanitized = raw.trim().replace(CONTROL_CHARS_REGEX, '');
  if (!sanitized) return null;

  // 역슬래시 → 슬래시
  sanitized = sanitized.replace(/\\/g, '/');

  // 앵커/상대경로
  if (ANCHOR_OR_RELATIVE_REGEX.test(sanitized)) {
    return sanitized;
  }

  // 프로토콜 상대 URL
  if (PROTOCOL_RELATIVE_REGEX.test(sanitized)) {
    return sanitized;
  }

  // 스킴 검사
  const scheme_match = sanitized.match(SCHEME_REGEX);
  if (scheme_match) {
    const scheme = scheme_match[1]?.toLowerCase();

    if (!scheme || !ALLOW_SCHEMES.has(scheme)) {
      return null; // 허용되지 않은 스킴
    }

    if (scheme === 'mailto' || scheme === 'tel') {
      return sanitized;
    }

    try {
      new URL(sanitized);
      return sanitized;
    } catch {
      return null;
    }
  }

  // 도메인 패턴
  if (DOMAIN_LIKE_REGEX.test(sanitized)) {
    const absolute_url = `https://${sanitized}`;
    try {
      new URL(absolute_url);
      return absolute_url;
    } catch {
      return null;
    }
  }

  // 상대경로
  return sanitized;
};
